import * as React from 'react';

import useHashScroll from '@/hooks/scroll/useHashScroll/HashScroll';
import { dayjst } from '@/lib/dayjst';
import { News } from '@/lib/microcms/model';
import { htmlToThemed } from '@/lib/microcms/parseHTML';

import ShareLinks from '../Partials/ShareLinks';
import { BodyWrapper, ContentHeader, PublishedAt, Title } from '../style';

interface NewsContentBodyProps {
  content: News;
}

const NewsContentBody: React.FC<NewsContentBodyProps> = ({ content }) => {
  useHashScroll();
  return (
    <>
      <ContentHeader>
        <PublishedAt>
          {dayjst(content.publishedAt || content.updatedAt).format('YYYY/M/D')}
        </PublishedAt>
        <Title>{content.title}</Title>
      </ContentHeader>
      <BodyWrapper>
        {htmlToThemed(content.body_v2 || content.body || '')}
      </BodyWrapper>
      <ShareLinks />
    </>
  );
};

export default NewsContentBody;
